import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-generic-error',
    templateUrl: './generic-error.component.html',
    styleUrls: ['./generic-error.component.scss'],
    standalone: false
})
export class GenericErrorComponent {
  validationError: boolean;
  title: string;
  invalidComponents: string[];

  constructor(public matdialogRef: MatDialogRef<GenericErrorComponent>, @Inject(MAT_DIALOG_DATA) private data: any) {
    this.validationError = data?.validationError;
    this.title = data?.title;
    this.invalidComponents = data?.invalidComponents || [];
  }

}
